import { getAxiosTotall } from "./ApiInstance";

export const LoginPhoneNumberApi=(info, callback)=>{
    getAxiosTotall().post("user/login/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const RegisterConfirmCode=(info, callback)=>{
    getAxiosTotall().post("/user/register/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const confirmCodeApi=(info, callback)=>{
    getAxiosTotall().post("user/verification/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};

export const RegisterApi=(info, callback)=>{
    getAxiosTotall().post("user/info/update/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const UpdateCartApi=(info, callback)=>{
    getAxiosTotall().post("/cart/update/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const getCourseListApi=async()=>{
    try{
        const result = await getAxiosTotall().get("course/")
        return result.data
    }catch(error){
        return error
    }
}
export const getCourseDetailApi=async(id)=>{
    try{
        const result = await getAxiosTotall().get(`course/${id}`)
        return result.data
    }catch(error){
        return error
    }
}

export const getShoppingBasketListApi=async()=>{
    try{
        const result = await getAxiosTotall().get(`cart/`)
        return result.data
    }catch(error){
        return error
    }
}


export const getUserInfoAPI=async()=>{
    try{
        const result = await getAxiosTotall().get(`user/info/`)
        return result.data
    }catch(error){
        return error
    }
}


export const getUserCourseAPI=async()=>{
    try{
        const result = await getAxiosTotall().get(`user/course/`)
        return result.data
    }catch(error){
        return error
    }
}


export const getUserCourseLisenceAPI=async()=>{
    try{
        const result = await getAxiosTotall().get(`user/course/license/`)
        return result.data
    }catch(error){
        return error
    }
}
export const getCommentUser=async(id)=>{
    try{
        const result = await getAxiosTotall().get(`user/comment/${id}/`)
        return result.data
    }catch(error){
        return error
    }
}
export const getQuestionUserAPI=async(id)=>{
    try{
        const result = await getAxiosTotall().get(`user/club/${id}/`)
        return result.data
    }catch(error){
        return error
    }
}
export const ForumCourseAPI=async()=>{
    try{
        const result = await getAxiosTotall().get(`user/club/`)
        return result.data
    }catch(error){
        return error
    }
}

export const getPageApi=async(type)=>{
    try{
        const result = await getAxiosTotall().get(`/page/${type}`)
        return result.data
    }catch(error){
        return error
    }
}


export const AddcomentAPI=(info, callback)=>{
    getAxiosTotall().post("user/comment/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};

export const addQuestionsAPi=(info, callback)=>{
    getAxiosTotall().post("user/club/question/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};

export const addAnswerAPi=(info, callback)=>{
    getAxiosTotall().post("user/club/answer/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};

export const PaymentPageApi=( callback)=>{
    getAxiosTotall().post("cart/pay/").then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
